import React from "react";
import { LoginForm } from "components/Forms/Login";

export function LoginModal(): JSX.Element {
  return <LoginForm inModal />;
}
